import React, { useEffect, useState } from 'react';
import './cart.css';
import { useSelector, useDispatch } from 'react-redux';
import { BsPlus } from "react-icons/bs";
import { BiMinus } from 'react-icons/bi';
import api from '../../api/api';
import { toast } from 'react-toastify';
import EmptyCart from '../../utils/zero-state-screens/Empty_Cart.svg';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import coverImg from '../../utils/cover-img.jpg';
import { RiCoupon2Fill, RiDeleteBinLine } from 'react-icons/ri';
import Loader from '../loader/Loader';
import Promo from './Promo';
import { useTranslation } from 'react-i18next';
import { addtoGuestCart, clearCartPromo, setCart, setCartProducts, setCartSubTotal } from '../../model/reducer/cartReducer';
import { ValidateNoInternet } from '../../utils/NoInternetValidator';
import { MdSignalWifiConnectedNoInternet0 } from 'react-icons/md';


const ViewCart = () => {


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const cart = useSelector(state => (state.cart));
    const city = useSelector(state => (state.city));
    const user = useSelector(state => (state.user));
    const location = useLocation();
    const sizes = useSelector(state => (state.productSizes));
    const setting = useSelector(state => (state.setting));
    const cartItems = cart?.cart?.data;
    const [productSizes, setproductSizes] = useState(null);
    const [iscartEmpty, setiscartEmpty] = useState(false);
    const [isLoader, setisLoader] = useState(false);
    const [showPromoOffcanvas, setShowPromoOffcanvas] = useState(false);
    const [cartProducts, setViewCartProducts] = useState([]);
    const [isNetworkError, setIsNetworkError] = useState(false);
    const [guestCartSubTotal, setGuestCartSubTotal] = useState(null);

    useEffect(() => {
        if (location.pathname == "/cart" && cart?.isGuest === false) {
            api.getCart(user?.jwtToken, city.city.latitude, city.city.longitude, 0)
                .then(response => response.json())
                .then(result => {
                    if (result.status === 1) {
                        // dispatch(setCartCheckout({ data: result.data }));
                        dispatch(setCart({ data: result }));
                        const enrichedCart = result?.data?.cart?.map((item) => {
                            // البحث عن المنتج في البيانات المحلية للحصول على اللون والمقاس المحددين
                            // نبحث أولاً باللون والمقاس إذا كان متوفراً
                            let existingLocal = null;
                            if (item?.selected_color || item?.selected_size) {
                                existingLocal = cart?.cartProducts?.find(p => 
                                    p.product_variant_id === item?.product_variant_id &&
                                    p.product_id === item?.product_id &&
                                    p.selected_color === item?.selected_color &&
                                    p.selected_size === item?.selected_size
                                );
                            }
                            
                            // إذا لم نجد، نبحث بدون اللون والمقاس
                            if (!existingLocal) {
                                existingLocal = cart?.cartProducts?.find(p => 
                                    p.product_variant_id === item?.product_variant_id &&
                                    p.product_id === item?.product_id
                                );
                            }
                            
                            // إذا لم نجد في البيانات المحلية، نحاول استخراج من البيانات التي تأتي من API
                            let selectedColor = existingLocal?.selected_color || item?.selected_color || null;
                            let selectedSize = existingLocal?.selected_size || item?.selected_size || null;
                            
                            // إذا لم تكن هناك بيانات محددة، نحاول استخراج من colors و size
                            if (!selectedColor && item?.colors) {
                                try {
                                    const colors = JSON.parse(item.colors);
                                    if (Array.isArray(colors) && colors.length > 0) {
                                        selectedColor = colors[0]; // نأخذ أول لون كافتراضي
                                    }
                                } catch (error) {
                                    console.error('Error parsing colors:', error);
                                }
                            }
                            
                            if (!selectedSize && item?.size) {
                                try {
                                    const sizes = JSON.parse(item.size);
                                    if (Array.isArray(sizes) && sizes.length > 0) {
                                        selectedSize = sizes[0]; // نأخذ أول مقاس كافتراضي
                                    }
                                } catch (error) {
                                    console.error('Error parsing sizes:', error);
                                }
                            }
                            
                            return {
                                ...item,
                                selected_color: selectedColor,
                                selected_size: selectedSize,
                            };
                        });
                        setViewCartProducts(enrichedCart);
                        const productsData = result?.data?.cart?.map((product) => {
                            // البحث عن المنتج في البيانات المحلية للحصول على اللون والمقاس المحددين
                            // نبحث أولاً باللون والمقاس إذا كان متوفراً
                            let existingLocal = null;
                            if (product?.selected_color || product?.selected_size) {
                                existingLocal = cart?.cartProducts?.find(p => 
                                    p.product_variant_id === product?.product_variant_id &&
                                    p.product_id === product?.product_id &&
                                    p.selected_color === product?.selected_color &&
                                    p.selected_size === product?.selected_size
                                );
                            }
                            
                            // إذا لم نجد، نبحث بدون اللون والمقاس
                            if (!existingLocal) {
                                existingLocal = cart?.cartProducts?.find(p => 
                                    p.product_variant_id === product?.product_variant_id &&
                                    p.product_id === product?.product_id
                                );
                            }
                            
                            let selectedColor = existingLocal?.selected_color || product?.selected_color || null;
                            let selectedSize = existingLocal?.selected_size || product?.selected_size || null;
                            
                            // إذا لم تكن هناك بيانات محددة، نحاول استخراج من colors و size
                            if (!selectedColor && product?.colors) {
                                try {
                                    const colors = JSON.parse(product.colors);
                                    if (Array.isArray(colors) && colors.length > 0) {
                                        selectedColor = colors[0];
                                    }
                                } catch (error) {
                                    console.error('Error parsing colors:', error);
                                }
                            }
                            
                            if (!selectedSize && product?.size) {
                                try {
                                    const sizes = JSON.parse(product.size);
                                    if (Array.isArray(sizes) && sizes.length > 0) {
                                        selectedSize = sizes[0];
                                    }
                                } catch (error) {
                                    console.error('Error parsing sizes:', error);
                                }
                            }
                            
                            return {
                                product_id: product?.product_id,
                                product_variant_id: product?.product_variant_id,
                                qty: product?.qty,
                                selected_color: selectedColor,
                                selected_size: selectedSize
                            };
                        });
                        dispatch(setCart({ data: result }));
                        dispatch(setCartProducts({ data: productsData }));
                        
                        // حساب المجموع الفرعي محلياً بدلاً من الاعتماد على الخادم
                        const localSubTotal = calculateLocalSubTotal(enrichedCart);
                        dispatch(setCartSubTotal({ data: localSubTotal }));
                    }

                })
                .catch(error => {
                    console.log(error);
                    const isNoInternet = ValidateNoInternet(error);
                    if (isNoInternet) {
                        setIsNetworkError(isNoInternet);
                    }
                });
        } else if (location.pathname == "/cart" && cart?.isGuest === true && cart?.guestCart?.length !== 0) {
            fetchGuestCart();
        } else if (location.pathname == "/cart" && cart?.isGuest === true && cart?.guestCart?.length === 0) {
            setiscartEmpty(true);
        }

    }, [user]);

    useEffect(() => {
        if (location.pathname == "/cart" && cart?.isGuest === true) {
            fetchGuestCart();
        }
    }, []);

    const fetchGuestCart = async () => {
        setisLoader(true);
        try {
            // إنشاء مصفوفة من جميع المنتجات بمقاسات مختلفة
            const allCartItems = cart?.guestCart || [];
            
            // إذا كانت السلة فارغة، تأكد من تعيين المجموع الكلي إلى 0
            if (allCartItems.length === 0) {
                setViewCartProducts([]);
                setGuestCartSubTotal(0);
                setiscartEmpty(true);
                setisLoader(false);
                return;
            }
            
            const variantIds = allCartItems.map((p) => p.product_variant_id);
            const quantities = allCartItems.map((p) => p.qty);
            
            const response = await api.getGuestCart(city?.city?.latitude, city?.city?.longitude, variantIds?.join(","), quantities?.join(","));
            const result = await response.json();
            if (result.status == 1) {
                // إنشاء مصفوفة من جميع المنتجات بمقاسات مختلفة
                const enrichedCart = [];
                
                // لكل منتج في guestCart، إنشاء عنصر منفصل
                allCartItems.forEach((cartItem) => {
                    // البحث عن البيانات المقابلة من API
                    const apiItem = result.data.cart.find(item => 
                        item.product_variant_id === cartItem.product_variant_id &&
                        item.product_id === cartItem.product_id
                    );
                    
                    if (apiItem) {
                        // دمج بيانات API مع بيانات السلة المحلية
                        const enrichedItem = {
                            ...apiItem,
                            qty: cartItem.qty,
                            selected_color: cartItem.selected_color || null,
                            selected_size: cartItem.selected_size || null,
                        };
                        
                        enrichedCart.push(enrichedItem);
                    }
                });
                
                setViewCartProducts(enrichedCart);
                
                // حساب المجموع الفرعي محلياً بدلاً من الاعتماد على الخادم
                const localSubTotal = calculateLocalSubTotal(enrichedCart);
                setGuestCartSubTotal(localSubTotal);
                
                if (enrichedCart.length > 0) {
                    setiscartEmpty(false);
                } else {
                    setiscartEmpty(true);
                    setGuestCartSubTotal(0);
                }
                            } else {
                    // إذا لم تكن هناك بيانات، تأكد من تعيين المجموع الكلي إلى 0
                    setViewCartProducts([]);
                    setGuestCartSubTotal(0);
                    setiscartEmpty(true);
                }
        } catch (e) {
            console.log(e?.message);
            // في حالة الخطأ، تأكد من تعيين المجموع الكلي إلى 0
            setViewCartProducts([]);
            setGuestCartSubTotal(0);
            setiscartEmpty(true);
        }
        setisLoader(false);
    };

    useEffect(() => {
        if (cart?.cartProducts?.length == 0 && cart?.isGuest === false) {
            setiscartEmpty(true);
        }
    }, [cart?.cartProducts]);

    // دالة لحساب المجموع الفرعي محلياً مع التحقق من تاريخ انتهاء الخصم
    const calculateLocalSubTotal = (products) => {
        if (!products || products.length === 0) {
            // إذا كانت السلة فارغة، تأكد من تعيين المجموع الكلي إلى 0
            setGuestCartSubTotal(0);
            return 0;
        }
        
        return products.reduce((total, product) => {
            const now = new Date();
            
            // التحقق من وجود بيانات الخصم
            let isDiscountActive = false;
            
            // إذا كان هناك سعر مخصوم وأقل من السعر الأصلي
            if (product?.discounted_price && 
                product?.discounted_price !== 0 && 
                product?.discounted_price < product?.price) {
                
                // إذا كان هناك تواريخ خصم، تحقق منها
                if (product?.discount_start_date && product?.discount_end_date) {
                    const startDate = new Date(product.discount_start_date);
                    const endDate = new Date(product.discount_end_date);
                    isDiscountActive = now >= startDate && now <= endDate;
                } else {
                    // إذا لم تكن هناك تواريخ خصم، استخدم السعر المخصوم دائماً
                    isDiscountActive = true;
                }
            }
            
            const price = isDiscountActive ? product.discounted_price : product.price;
            
            return total + (price * product.qty);
        }, 0);
    };

    //Add to Cart
    const addtoCart = async (product_id, product_variant_id, qty, selectedColor, selectedSize) => {
        // setisLoader(true);
        await api.addToCart(user?.jwtToken, product_id, product_variant_id, qty, selectedColor, selectedSize)
            .then(response => response.json())
            .then(async (result) => {
                if (result.status === 1) {
                    // toast.success(result.message);
                    dispatch(clearCartPromo());
                    
                    // إنشاء مفتاح فريد للمنتج
                    const productKey = `${product_id}_${product_variant_id}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
                    
                    const updatedCartProducts = cartProducts?.map(product => {
                        const cartProductKey = `${product?.product_id}_${product?.product_variant_id}_${product?.selected_color || 'no-color'}_${product?.selected_size || 'no-size'}`;
                        if (cartProductKey === productKey) {
                            return { ...product, qty: qty };
                        } else {
                            return product;
                        }
                    });
                    setViewCartProducts(updatedCartProducts);
                    
                    const updatedProducts = cart?.cartProducts?.map((product) => {
                        const cartProductKey = `${product?.product_id}_${product?.product_variant_id}_${product?.selected_color || 'no-color'}_${product?.selected_size || 'no-size'}`;
                        if (cartProductKey === productKey) {
                            return { ...product, qty: qty };
                        } else {
                            return product;
                        }
                    });
                    dispatch(setCartProducts({ data: updatedProducts }));
                    
                    // حساب المجموع الفرعي محلياً بدلاً من الاعتماد على الخادم
                    const localSubTotal = calculateLocalSubTotal(updatedCartProducts);
                    dispatch(setCartSubTotal({ data: localSubTotal }));
                    
                    // إذا أصبحت السلة فارغة
                    if (updatedCartProducts.length === 0) {
                        setiscartEmpty(true);
                    }
                }
                else {
                    // setisLoader(false);
                    toast.error(result.message);
                }
            });
        // setisLoader(false);
    };

    //remove from Cart
    const removefromCart = async (product_id, product_variant_id, selectedColor, selectedSize) => {
        // setisLoader(true);
        
        await api.removeFromCart(user?.jwtToken, product_id, product_variant_id, selectedColor, selectedSize)
            .then(response => response.json())
            .then(async (result) => {
                if (result.status === 1) {
                    // toast.success(result.message);
                    dispatch(clearCartPromo());
                    // إنشاء مفتاح فريد للمنتج
                    const productKey = `${product_id}_${product_variant_id}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
                    
                    const updatedCartProducts = cart?.cartProducts?.filter(product => {
                        // حذف المنتج المحدد فقط (نفس product_id, product_variant_id, selected_color, selected_size)
                        const cartProductKey = `${product?.product_id}_${product?.product_variant_id}_${product?.selected_color || 'no-color'}_${product?.selected_size || 'no-size'}`;
                        return cartProductKey !== productKey;
                    });
                    dispatch(setCartProducts({ data: updatedCartProducts ? updatedCartProducts : [] }));
                    
                    const updatedProducts = cartProducts?.filter(product => {
                        // حذف المنتج المحدد فقط (نفس product_id, product_variant_id, selected_color, selected_size)
                        const cartProductKey = `${product?.product_id}_${product?.product_variant_id}_${product?.selected_color || 'no-color'}_${product?.selected_size || 'no-size'}`;
                        return cartProductKey !== productKey;
                    });
                    setViewCartProducts(updatedProducts);
                    
                    // حساب المجموع الفرعي محلياً بدلاً من الاعتماد على الخادم
                    const localSubTotal = calculateLocalSubTotal(updatedProducts);
                    dispatch(setCartSubTotal({ data: localSubTotal }));
                    
                    // إذا أصبحت السلة فارغة
                    if (updatedProducts.length === 0) {
                        setiscartEmpty(true);
                    }
                }
                else {
                    // setisLoader(false);
                    toast.error(result.message);
                }
            })
            .catch(error => console.log(error));
    };
    const { t } = useTranslation();
    const placeHolderImage = (e) => {

        e.target.src = setting.setting?.web_logo;
    };

    const stockValidation = () => {
        cart.cart?.data?.cart.forEach(element => {
            if (!element.status) {
                return () => {
                    toast.error(t('some_items_are_out_of_stock'));
                };
            }
            navigate('/checkout');
        });
    };

    function getProductQuantities(products) {
        if (!products || !Array.isArray(products) || products.length === 0) {
            return [];
        }
        return Object.entries(products.reduce((quantities, product) => {
            if (!product || !product.product_id) {
                return quantities;
            }
            // إنشاء مفتاح فريد يتضمن product_id و product_variant_id و اللون والمقاس
            const uniqueKey = `${product.product_id}_${product.product_variant_id}_${product.selected_color || 'no-color'}_${product.selected_size || 'no-size'}`;
            const existingQty = quantities[uniqueKey] || 0;
            return { ...quantities, [uniqueKey]: existingQty + (product.qty || 0) };
        }, {})).map(([uniqueKey, qty]) => {
            const parts = uniqueKey.split('_');
            const productId = parts[0];
            const variantId = parts[1];
            const color = parts[2];
            const size = parts[3];
            return {
                product_id: parseInt(productId),
                product_variant_id: parseInt(variantId),
                selected_color: color === 'no-color' ? null : color,
                selected_size: size === 'no-size' ? null : size,
                qty
            };
        });
    }

    const AddToGuestCart = (productId, productVariantId, Qty, isExisting, selectedColor, selectedSize) => {
        if (isExisting) {
            
            // إنشاء مفتاح فريد للمنتج
            const productKey = `${productId}_${productVariantId}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
            
            const updatedProducts = cart?.guestCart?.map((product) => {
                const cartProductKey = `${product?.product_id}_${product?.product_variant_id}_${product?.selected_color || 'no-color'}_${product?.selected_size || 'no-size'}`;
                if (cartProductKey === productKey) {
                    return { ...product, qty: Qty };
                } else {
                    return product;
                }
            }).filter(product => product?.qty !== 0);
            
            const updatedCartProducts = cartProducts?.map(product => {
                const cartProductKey = `${product?.product_id}_${product?.product_variant_id}_${product?.selected_color || 'no-color'}_${product?.selected_size || 'no-size'}`;
                if (cartProductKey === productKey) {
                    return { ...product, qty: Qty };
                } else {
                    return product;
                }
            }).filter(product => product?.qty !== 0);
            
            if (updatedCartProducts.length === 0) {
                // إذا أصبحت السلة فارغة
                setViewCartProducts([]);
                setGuestCartSubTotal(0);
                setiscartEmpty(true);
            } else {
                computeSubTotal(updatedCartProducts);
                setViewCartProducts(updatedCartProducts);
            }
            
            dispatch(addtoGuestCart({ data: updatedProducts }));
        } else {
            // البحث عن المنتج الحالي للحصول على البيانات الإضافية
            const currentProduct = cartProducts?.find(p => 
                p.product_id === productId && 
                p.product_variant_id === productVariantId
            );
            
            const productData = { 
                product_id: productId, 
                product_variant_id: productVariantId, 
                qty: Qty,
                selected_color: selectedColor,
                selected_size: selectedSize
            };
            dispatch(addtoGuestCart({ data: [...cart?.guestCart, productData] }));
            
            // تحديث cartProducts والمجموع الكلي عند إضافة منتج جديد
            const newCartData = [...cartProducts, { ...currentProduct, qty: Qty, selected_color: selectedColor, selected_size: selectedSize }];
            setViewCartProducts(newCartData);
            computeSubTotal(newCartData);
        }
    };
    const computeSubTotal = (products) => {
        // إذا كانت السلة فارغة، تأكد من تعيين المجموع الكلي إلى 0
        if (!products || products.length === 0) {
            setGuestCartSubTotal(0);
            return;
        }
        
        const subTotal = products.reduce((prev, curr) => {
            const now = new Date();
            
            // التحقق من وجود بيانات الخصم
            let isDiscountActive = false;
            
            // إذا كان هناك سعر مخصوم وأقل من السعر الأصلي
            if (curr?.discounted_price && 
                curr?.discounted_price !== 0 && 
                curr?.discounted_price < curr?.price) {
                
                // إذا كان هناك تواريخ خصم، تحقق منها
                if (curr?.discount_start_date && curr?.discount_end_date) {
                    const startDate = new Date(curr.discount_start_date);
                    const endDate = new Date(curr.discount_end_date);
                    isDiscountActive = now >= startDate && now <= endDate;
                } else {
                    // إذا لم تكن هناك تواريخ خصم، استخدم السعر المخصوم دائماً
                    isDiscountActive = true;
                }
            }
            
            const price = isDiscountActive ? curr.discounted_price : curr.price;
            prev += price * curr.qty;
            return prev;
        }, 0);
        setGuestCartSubTotal(subTotal);
    };
    const RemoveFromGuestCart = (productVariantId, selectedColor, selectedSize) => {
        // البحث عن المنتج في البيانات المحلية للحصول على product_id
        const currentProduct = cartProducts?.find(p => p.product_variant_id === productVariantId);
        
        // إنشاء مفتاح فريد للمنتج
        const productKey = `${currentProduct?.product_id}_${productVariantId}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
        
        const updatedProducts = cart?.guestCart?.filter((p) => {
            const cartProductKey = `${p.product_id}_${p.product_variant_id}_${p.selected_color || 'no-color'}_${p.selected_size || 'no-size'}`;
            return cartProductKey !== productKey;
        });
        
        const updatedSideBarProducts = cartProducts.filter((p) => {
            const cartProductKey = `${p.product_id}_${p.product_variant_id}_${p.selected_color || 'no-color'}_${p.selected_size || 'no-size'}`;
            return cartProductKey !== productKey;
        });
        if (updatedSideBarProducts.length === 0) {
            // إذا أصبحت السلة فارغة
            setViewCartProducts([]);
            setGuestCartSubTotal(0);
            setiscartEmpty(true);
        } else {
            computeSubTotal(updatedSideBarProducts);
            setViewCartProducts(updatedSideBarProducts);
        }
        
        dispatch(addtoGuestCart({ data: updatedProducts }));
    };

    const handleValidateAddExistingGuestProduct = (productQuantity, product, quantity) => {
        // البحث عن المنتج المحدد باللون والمقاس في السلة
        const selectedColor = product?.selected_color || null;
        const selectedSize = product?.selected_size || null;
        
        // إنشاء مفتاح فريد للمنتج
        const productKey = `${product?.product_id}_${product?.product_variant_id}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
        
        // البحث عن المنتج المحدد في السلة
        const existingProduct = cart?.guestCart?.find(p => {
            const cartProductKey = `${p.product_id}_${p.product_variant_id}_${p.selected_color || 'no-color'}_${p.selected_size || 'no-size'}`;
            return cartProductKey === productKey;
        });
        
        if (Number(product.is_unlimited_stock)) {
            if (existingProduct?.qty >= Number(product?.total_allowed_quantity)) {
                toast.error(t("max_cart_limit_error"));
            }
            else {
                AddToGuestCart(product?.product_id, product?.product_variant_id, quantity, 1, selectedColor, selectedSize);
            }
        }
        else {
            if (existingProduct?.qty >= Number(product?.total_allowed_quantity)) {
                toast.error(t("max_cart_limit_error"));
            }
            else if (existingProduct?.qty >= Number(product?.stock)) {
                toast.error(t("limited_product_stock_error"));
            }
            else {
                AddToGuestCart(product?.product_id, product?.product_variant_id, quantity, 1, selectedColor, selectedSize);
            }
        }
    };

    return (
        <>
            {!isNetworkError ?
                <section id='viewcart' className='viewcart'>
                    <div className='cover'>
                        <img src={coverImg} onError={placeHolderImage} className='img-fluid' alt="cover"></img>
                        <div className='title'>
                            <h3>{t("cart")}</h3>
                            <span><Link to='/' className='text-light text-decoration-none'>{t("home")} / </Link></span><span className='active'>{t('cart')}</span>
                        </div>

                    </div>

                    <div className="view-cart-container">
                        <div className='container'>

                            {iscartEmpty ? (
                                <div className='empty-cart co-12'>
                                    <img src={EmptyCart} onError={placeHolderImage} alt='empty-cart'></img>
                                    <p>{t("empty_cart_list_message")}</p>
                                    <span>{t("empty_cart_list_description")}</span>
                                    <button type='button' onClick={() => {
                                        navigate('/products');
                                    }}>{t("empty_cart_list_button_name")}</button>
                                </div>) : (
                                <>
                                    <>
                                        {isLoader ? <Loader screen='full' background='none' /> : null}
                                        <div className="row justify-content-center">

                                            <div className='viewcart-product-wrapper col-8'>
                                                <div className='product-heading'>
                                                    <h3>{t("your_cart")}</h3>
                                                    <span>{t("there_are")} </span><span className='title'>{cart?.isGuest === false ? cart?.cartProducts?.length : cart?.guestCart?.length}</span> <span> {t("product_in_your_cart")}  </span>
                                                </div>

                                                <table className='products-table table'>
                                                    <thead>
                                                        <tr>
                                                            <th className='first-column'>{t("product")}</th>
                                                            <th className='hide-mobile'>{t("unit")}</th>
                                                            <th>{t("color")}</th>
                                                            <th>{t("size")}</th>
                                                            <th>{t("price")}</th>
                                                            <th>{t("quantity")}</th>
                                                            <th className='hide-mobile'>{t("sub_total")}</th>
                                                            <th className='last-column'>{t("remove")}</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {cartProducts?.map((product, index) => {
                                                            // Determine selected color/size from API data or local cart state
                                                            const selectedColor = product.selected_color || null;
                                                            const selectedSize = product.selected_size || null;
                                                            
                                                            // إنشاء مفتاح فريد للمنتج
                                                            const productKey = `${product.product_id}_${product.product_variant_id}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
                                                            
                                                            const sourceProduct = cart?.isGuest
                                                                ? cart?.guestCart?.find(p => {
                                                                    const cartProductKey = `${p?.product_id}_${p?.product_variant_id}_${p?.selected_color || 'no-color'}_${p?.selected_size || 'no-size'}`;
                                                                    return cartProductKey === productKey;
                                                                })
                                                                : cart?.cartProducts?.find(p => {
                                                                    const cartProductKey = `${p?.product_id}_${p?.product_variant_id}_${p?.selected_color || 'no-color'}_${p?.selected_size || 'no-size'}`;
                                                                    return cartProductKey === productKey;
                                                                });

                                                            // البحث عن المنتج في السلة مع مراعاة اللون والمقاس

                                                            // البحث عن المنتج في السلة مع مراعاة اللون والمقاس
                                                            const cartProduct = cart?.isGuest
                                                                ? cart?.guestCart?.find((prdct) => {
                                                                    const cartProductKey = `${prdct?.product_id}_${prdct?.product_variant_id}_${prdct?.selected_color || 'no-color'}_${prdct?.selected_size || 'no-size'}`;
                                                                    return cartProductKey === productKey;
                                                                })
                                                                : cart?.cartProducts?.find((prdct) => {
                                                                    const cartProductKey = `${prdct?.product_id}_${prdct?.product_variant_id}_${prdct?.selected_color || 'no-color'}_${prdct?.selected_size || 'no-size'}`;
                                                                    return cartProductKey === productKey;
                                                                });

                                                            if (cartProduct?.qty > 0) {
                                                                return (
                                                                    <tr key={index} className={`${!product.status ? "danger" : ""}`}>
                                                                        <th className='products-image-container first-column'>
                                                                            <div className='image-container'>
                                                                                <img onError={placeHolderImage} src={product.image_url} alt='product'></img>
                                                                            </div>

                                                                            <div className=''>
                                                                                <span>{product.measurement} {product.unit_code} | {product.name}</span>
                                                                                {/* Add variant details */}
                                                                                {(selectedColor || selectedSize) && (
                                                                                    <div className="cart-item-variant-details">
                                                                                        {selectedColor && (
                                                                                            <div className="cart-item-color">
                                                                                                <span>{t("color")}</span>
                                                                                                <div className="cart-item-color-swatch" style={{ backgroundColor: selectedColor }} />
                                                                                            </div>
                                                                                        )}
                                                                                        {selectedSize && (
                                                                                            <div className="cart-item-size">
                                                                                                <span>{t("size")}: {selectedSize}</span>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </th>
                                                                        <td className='hide-mobile'>{product.measurement} {product.unit_code}</td>
                                                                        {/* Color Column */}
                                                                        <td>
                                                                            {selectedColor ? (
                                                                                <span className="table-color-swatch" style={{ backgroundColor: selectedColor }} title={selectedColor}></span>
                                                                                ) : (
                                                                                "-"
                                                                                )}
                                                                         </td>
                                                                        {/* Size Column */}
                                                                        <td>{selectedSize || "-"}</td>
                                                                         <td className='price'>
                                                                             {(() => {
                                                                                 const now = new Date();
                                                                                 const startDate = product?.discount_start_date ? new Date(product.discount_start_date) : null;
                                                                                 const endDate = product?.discount_end_date ? new Date(product.discount_end_date) : null;
                                                                                 const isDiscountActive = product?.discounted_price && 
                                                                                                        product?.discounted_price !== 0 && 
                                                                                                        product?.discounted_price < product?.price &&
                                                                                                        (startDate && endDate ? (now >= startDate && now <= endDate) : true);

                                                                                 return isDiscountActive 
                                                                                     ? product.discounted_price.toFixed(setting.setting && setting.setting.decimal_point)
                                                                                     : product.price.toFixed(setting.setting && setting.setting.decimal_point);
                                                                             })()}
                                                                         </td>

                                                                        <td className='quantity'>
                                                                            <div>
                                                                                <button
                                                                                    type='button'
                                                                                    onClick={() => {
                                                                                        if (cart?.isGuest) {
                                                                                            if (cartProduct?.qty > 1) {
                                                                                                // Reduce quantity by 1
                                                                                                AddToGuestCart(product.product_id, product.product_variant_id, cartProduct?.qty - 1, 1, selectedColor, selectedSize);
                                                                                            } else {
                                                                                                // Quantity is 1 – remove the item entirely
                                                                                                RemoveFromGuestCart(product.product_variant_id, selectedColor, selectedSize);
                                                                                            }
                                                                                                                } else {
                            if (cartProduct?.qty > 1) {
                                addtoCart(product.product_id, product.product_variant_id, cartProduct?.qty - 1, selectedColor, selectedSize);
                            } else {
                                // Quantity is 1 – remove from server cart
                                removefromCart(product.product_id, product.product_variant_id, selectedColor, selectedSize);
                            }
                        }
                                                                                    }}>
                                                                                    <BiMinus fill='#fff' fontSize={'2rem'} />
                                                                                </button>

                                                                                <span >{cartProduct?.qty}</span>

                                                                                <button
                                                                                    type='button'
                                                                                    onClick={() => {
                                                                                        if (cart?.isGuest) {
                                                                                            const productQuantity = getProductQuantities(cart?.guestCart);
                                                                                            handleValidateAddExistingGuestProduct(
                                                                                                productQuantity,
                                                                                                product,
                                                                                                cartProduct?.qty + 1
                                                                                            );
                                                                                        } else {
                                                                                            const productQuantity = getProductQuantities(cart?.cartProducts);
                                                                                            if (Number(product.is_unlimited_stock) === 1) {
                                                                                                // إنشاء مفتاح فريد للمنتج
                                                                                                const productKey = `${product?.product_id}_${product?.product_variant_id}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
                                                                                                const existingProduct = productQuantity?.find(p => {
                                                                                                    const cartProductKey = `${p?.product_id}_${p?.product_variant_id}_${p?.selected_color || 'no-color'}_${p?.selected_size || 'no-size'}`;
                                                                                                    return cartProductKey === productKey;
                                                                                                });
                                                                                                
                                                                                                if (existingProduct?.qty < Number(product?.total_allowed_quantity)) {
                                                                                                    addtoCart(product.product_id, product.product_variant_id, cartProduct?.qty + 1, selectedColor, selectedSize);
                                                                                                } else {
                                                                                                    toast.error(t("max_cart_limit_error"));
                                                                                                }
                                                                                            } else {
                                                                                                if (Number(product.qty) >= Number(product.stock)) {
                                                                                                    toast.error(t("out_of_stock_message"));
                                                                                                } else {
                                                                                                    // إنشاء مفتاح فريد للمنتج
                                                                                                    const productKey = `${product?.product_id}_${product?.product_variant_id}_${selectedColor || 'no-color'}_${selectedSize || 'no-size'}`;
                                                                                                    const existingProduct = productQuantity?.find(p => {
                                                                                                        const cartProductKey = `${p?.product_id}_${p?.product_variant_id}_${p?.selected_color || 'no-color'}_${p?.selected_size || 'no-size'}`;
                                                                                                        return cartProductKey === productKey;
                                                                                                    });
                                                                                                    
                                                                                                    if (existingProduct?.qty >= Number(product?.total_allowed_quantity)) {
                                                                                                        toast.error(t("max_cart_limit_error"));
                                                                                                    } else {
                                                                                                        addtoCart(product.product_id, product.product_variant_id, cartProduct?.qty + 1, selectedColor, selectedSize);
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }}>
                                                                                    <BsPlus fill='#fff' fontSize={'2rem'} />
                                                                                </button>
                                                                            </div>

                                                                        </td>

                                                                        <td className='subtotal hide-mobile price-saudi'>
                                                                            {(() => {
                                                                                const now = new Date();
                                                                                const startDate = product?.discount_start_date ? new Date(product.discount_start_date) : null;
                                                                                const endDate = product?.discount_end_date ? new Date(product.discount_end_date) : null;
                                                                                const isDiscountActive = product?.discounted_price && 
                                                                                                       product?.discounted_price !== 0 && 
                                                                                                       product?.discounted_price < product?.price &&
                                                                                                       (startDate && endDate ? (now >= startDate && now <= endDate) : true);

                                                                                const price = isDiscountActive ? product.discounted_price : product.price;
                                                                                return (price.toFixed(setting.setting && setting.setting.decimal_point) * cartProduct?.qty).toFixed(setting.setting && setting.setting.decimal_point);
                                                                            })()}
                                                                        </td>

                                                                        <td className='remove last-column'>
                                                                            <button
                                                                                whiletap={{ scale: 0.8 }}
                                                                                type='button'
                                                                                onClick={() => {
                                                                                    if (cart?.isGuest) {
                                                                                        RemoveFromGuestCart(product.product_variant_id, selectedColor, selectedSize);
                                                                                    } else {
                                                                                        removefromCart(product.product_id, product.product_variant_id, selectedColor, selectedSize);
                                                                                    }
                                                                                }}>
                                                                                <RiDeleteBinLine fill='red' fontSize={'2.985rem'} />
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            }
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="billing col-3">
                                                {cart?.isGuest === false ?
                                                    <div className="promo-section mb-3">
                                                        <div className="heading">
                                                            <span>{t("coupon")}</span>
                                                        </div>
                                                        <div className="promo-wrapper">
                                                            <div className="promo-container">
                                                                <div className="promo-button ">
                                                                    <span className="">{t("have_coupon")}</span>
                                                                    <button className="btn" onClick={() => setShowPromoOffcanvas(true)}>{t("view_coupon")}</button>
                                                                </div>
                                                                {cart.cart && cart.promo_code ?
                                                                    <>
                                                                        <div className="promo-code">
                                                                            <div className="">
                                                                                <span><RiCoupon2Fill size={26} fill='var(--secondary-color)' /></span>
                                                                            </div>
                                                                            <div className="d-flex flex-column">
                                                                                <span className='promo-name'>{cart.promo_code.promo_code}</span>
                                                                                <span className='promo-discount-amount'>{cart.promo_code.message}</span>
                                                                            </div>
                                                                            <div className="d-flex flex-column">
                                                                                <span className='price-saudi'>{cart.promo_code.discount.toFixed(setting.setting && setting.setting.decimal_point)}</span>
                                                                                <span className='promo-remove' onClick={() => {
                                                                                    dispatch(clearCartPromo());
                                                                                    toast.info("Coupon Removed");
                                                                                }}> {t("remove")}</span>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    : <></>}
                                                            </div>
                                                        </div>

                                                    </div> : null}
                                                <div className='cart-summary-wrapper'>
                                                    <div className='heading'>
                                                        <span >{t("cart")} {t("total")}</span>
                                                    </div>
                                                    {cart.cartSubTotal === null
                                                        ? (<div className="d-flex justify-content-center">
                                                            <div className="spinner-border" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        </div>)
                                                        : (
                                                            <div className='summary'>
                                                                <div className='d-flex justify-content-between'>
                                                                    <span>{t("sub_total")}</span>
                                                                    <div className='d-flex align-items-center price-saudi flex-row-reverse'>
                                                                       
                                                                        <span>{
                                                                            cart?.isGuest === false ?
                                                                                (cart?.cartSubTotal)?.toFixed(setting.setting && setting.setting.decimal_point)
                                                                                :
                                                                                guestCartSubTotal?.toFixed(setting.setting && setting.setting.decimal_point)
                                                                        }</span>
                                                                    </div>
                                                                </div>
                                                                {cart.promo_code && <>
                                                                    <div className='d-flex justify-content-between'>
                                                                        <span>{t("discount")}</span>
                                                                        <div className='d-flex align-items-center'>

                                                                            <span className='price-saudi'>-  {(cart?.promo_code.discount)?.toFixed(setting.setting && setting.setting.decimal_point)}</span>
                                                                        </div>
                                                                    </div>
                                                                </>}
                                                                <div className='d-flex justify-content-center mt-3 button-container'>
                                                                    <button
                                                                        type='button'
                                                                        onClick={() => {
                                                                            // console.log("cart", cart?.isGuest)
                                                                            if (cart?.isGuest) {
                                                                                // toast.error("login");
                                                                                toast.error(t("login_to_access_checkout_page"));
                                                                            } else {
                                                                                stockValidation();
                                                                            }
                                                                        }}
                                                                        className='checkout cursorPointer'>
                                                                        {t("proceed_to_checkout")}
                                                                    </button>
                                                                </div>

                                                            </div>)}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                </>
                            )}
                        </div>
                    </div>
                    <Promo show={showPromoOffcanvas} setShow={setShowPromoOffcanvas} />
                </section>
                :
                <div className='d-flex flex-column justify-content-center align-items-center noInternetContainer'>
                    <MdSignalWifiConnectedNoInternet0 />
                    <p>{t("no_internet_connection")}</p>
                </div>
            }
        </>
    );
};

export default ViewCart;

/*
 * التحديثات المضافة في صفحة ViewCart:
 * 
 * 1. إصلاح حساب الخصم في دالة calculateLocalSubTotal:
 *    - تم إزالة المتغير USE_DISCOUNT_WITHOUT_DATES
 *    - تم تعديل منطق التحقق من الخصم ليطبق الخصم دائماً إذا لم تكن هناك تواريخ محددة
 *    - إذا كانت هناك تواريخ خصم، يتم التحقق من أن التاريخ الحالي ضمن نطاق الخصم
 * 
 * 2. إصلاح حساب الخصم في دالة computeSubTotal:
 *    - نفس الإصلاحات المطبقة على calculateLocalSubTotal
 * 
 * 3. إصلاح عرض الأسعار في واجهة المستخدم:
 *    - تم تعديل منطق isDiscountActive في عرض سعر الوحدة
 *    - تم تعديل منطق isDiscountActive في حساب المجموع الفرعي
 *    - الآن يتم عرض السعر المخصوم إذا كان متوفراً وأقل من السعر الأصلي
 * 
 * ✅ تم إصلاح مشكلة عدم احتساب الخصم في ViewCart بنجاح!
 */
